import { render, staticRenderFns } from "./header-search.vue?vue&type=template&id=f99cb56c&scoped=true&"
import script from "./header-search.vue?vue&type=script&lang=js&"
export * from "./header-search.vue?vue&type=script&lang=js&"
import style0 from "./header-search.vue?vue&type=style&index=0&id=f99cb56c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99cb56c",
  null
  
)

export default component.exports